import { render, staticRenderFns } from "./AssessmentCard.vue?vue&type=template&id=571df7e0"
import script from "./AssessmentCard.vue?vue&type=script&lang=js"
export * from "./AssessmentCard.vue?vue&type=script&lang=js"
import style0 from "./AssessmentCard.vue?vue&type=style&index=0&id=571df7e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports